import React, { useCallback } from 'react';
import Button from 'src/components/Button';
import Toast from 'src/components/Toast';
import { IPaginationParams, IPaginationResponse } from 'src/models/interfaces/pagination';
import fleetsService from 'src/service/fleetsService';
import { Results } from 'src/types/ICollaborators';
import GridItem from './gridItem';
import TablePagination from './pagination';
import { GridContainer, Header, MessageTD, Table, TBody, TFoot, THead } from './styles';

interface IProps {
  data: IPaginationResponse<Results>;
  error: boolean;
  loading: boolean;
  params: IPaginationParams;
  mergeParams: (newParams: Partial<IPaginationParams>) => void;
}

const DataGrid = (props: IProps) => {
  const { data, error, loading, params, mergeParams } = props;
  const toast = Toast();

  const { total, results } = data || ({ total: 0, results: [] } as typeof data);

  const handleExport = useCallback(() => {
    fleetsService
      .ordersReport(params)
      .then(({ data }) => {
        const url = window.URL.createObjectURL(data);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'Relatório de Solicitções de compra.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => toast.error());
  }, [params]);

  return (
    <>
      <Header>
        <div className='right'>
          <Button fill={false} onClick={handleExport}>
            Exportar dados
          </Button>
        </div>
      </Header>
      <GridContainer>
        <Table>
          <THead>
            <tr>
              <th>Nome Completo</th>
              <th>GPID</th>
              <th>Nível</th>
              <th>E-mail</th>
              <th>Data de admição</th>
            </tr>
          </THead>
          <TBody>
            {error ? (
              <tr>
                <MessageTD>Houve um erro ao obter os registros.</MessageTD>
              </tr>
            ) : loading ? (
              <tr>
                <MessageTD>Carregando...</MessageTD>
              </tr>
            ) : results.length > 0 ? (
              results.map(d => (
                <GridItem key={d.id} item={d} />
              ))
            ) : (
              <tr>
                <MessageTD>Nenhum registro encontrado.</MessageTD>
              </tr>
            )}
          </TBody>
          <TFoot>
            <tr>
              <TablePagination
                colSpan={30}
                total={total}
                disabled={loading}
                paginationParams={params}
                onChange={mergeParams}
              />
            </tr>
          </TFoot>
        </Table>
      </GridContainer>
    </>
  );
};

export default DataGrid;
